import React, { Component, PropTypes } from 'react';
import InputPassword from 'vendor/react-ux-password-field/src';
import { connectReduxForm } from 'redux-form';
import { validateChangePassword } from 'utils/validateNormalize';
import Spinner from 'react-spinner';
import 'react-spinner/react-spinner.css';
import './spinnerButton.scss';

@connectReduxForm({
  form: 'changePassword',
  fields: ['oldPassword', 'newPassword', 'alert'],
  validate: validateChangePassword
})
export default class ChangeTempPasswordForm extends Component {

  static propTypes = {
    tempPassword: PropTypes.string,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  }

  handleSubmit (evt) {
    const {
      fields: {
        alert
      },
      handleSubmit
    } = this.props;
    alert.submitError = false;
    handleSubmit(evt);
  }

  render () {
    const {
      tempPassword,
      fields: {
        alert,
        oldPassword,
        newPassword
      },
      submitting
    } = this.props;

    return (
      <form
          className="form-horizontal"
          onSubmit={::this.handleSubmit}>
        { alert.error &&
          <div className="form-group">
            <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: alert.error}}></div>
          </div>
        }

        <div className="row">
          <div className="col-sm-8 col-md-6">

            { (!tempPassword || !oldPassword.value || oldPassword.error) &&
              <div
                  className={
                    'form-group ' +
                    (oldPassword.error &&
                     oldPassword.touched ? 'has-error' : '')
                  }>
                <label
                    htmlFor="txtOldPassword"
                    className="col-sm-2 control-label">
                  Temporary Password
                </label>
                <div className="col-sm-9">
                  <input
                      id="txtOldPassword"
                      type="password"
                      className="form-control"
                      placeholder="thoo!mu3Da"
                      {...oldPassword} />
                  { oldPassword.error && oldPassword.touched &&
                    <div className="text-danger" dangerouslySetInnerHTML={{__html: oldPassword.error}}></div>
                  }
                </div>
              </div>
            }

            <div
                className={
                  'form-group ' +
                  (newPassword.error &&
                   newPassword.touched ? 'has-error' : '')
                }>
              <label
                  htmlFor="txtNewPassword"
                  className="col-sm-2 control-label">
                New Password
              </label>
              <div className="col-sm-9">
                <InputPassword
                    id="txtNewPassword"
                    className="form-control"
                    placeholder="thoo!mu3Da"
                    autoComplete="off"
                    minLength={8}
                    toggleMask={false}
                    {...newPassword} />
                { newPassword.error && newPassword.touched &&
                  <div className="text-danger" dangerouslySetInnerHTML={{__html: newPassword.error}}></div>
                }
              </div>
            </div>

          </div>
        </div>

        <button type="submit"
                className={'btn btn-primary spinnerButton ' +
                           (submitting ? 'disabled' : '')}>
          <div className="buttonContent">
            <div className="buttonText">
              {submitting ?
                'Changing' :
                'Change'
              }
            </div>
            {submitting &&
            <div className="spinnerWrapper">
              <Spinner />
            </div>
            }
          </div>
        </button>

      </form>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/changeTempPasswordForm.jsx